/* r33 (27 Eki 2026): Dawn'ın ModalDialog kurucusu içinde
   [id^="ModalClose-"] düğmesini arıyor; tema özel büyütme penceresi (.thlb)
   kullandığı için bazı product-modal öğelerinde bu düğme yok ve konsola
   "Cannot read properties of null (addEventListener)" hatası düşüyordu.
   Tanımdan önce eksik düğme gizli olarak ekleniyor; showActiveMedia da
   eşleşen medya yoksa sessizce çıkıyor. */
(function () {
  function tamamla(root) {
    (root || document).querySelectorAll('product-modal').forEach(function (m) {
      if (!m.querySelector('[id^="ModalClose-"]')) {
        var b = document.createElement('button');
        b.type = 'button';
        b.hidden = true;
        b.tabIndex = -1;
        b.id = 'ModalClose-th' + Math.random().toString(36).slice(2, 8);
        b.setAttribute('aria-hidden', 'true');
        m.appendChild(b);
      }
    });
  }
  tamamla();
  window.thModalTamamla = tamamla;
})();

if (!customElements.get('product-modal') && typeof ModalDialog !== 'undefined') {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        if (window.thModalTamamla) window.thModalTamamla();
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) return;
        const id = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${id}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${id}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
